import { useFetch } from '../../../hooks/useFetch';
import { EmployeeTransport } from '../../../models/employee-transport';
import { errorNotification } from '../../../providers/mantine-notifications';
import { translateServerHttpErrors } from '../../../utils/helpers';
import {
  UseGetEmployeeTransportReceiptProps,
  UseGetUserEmployeeTransportProps,
} from '../../../utils/types/data/hooks/employee-transport';
import { PaginatedResponse } from '../../../utils/types/data/pagination';
import {
  createManyEmployeeTransportRequest,
  getEmployeeTransportListRequest,
  inactivateEmployeeTransportRequest,
} from '../../employee-transport';

export function useGetUserEmployeeTransport() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<PaginatedResponse<EmployeeTransport>>();

  const fetch = ({ data, onSuccess }: UseGetUserEmployeeTransportProps) =>
    fetchData({
      fetcher: () => getEmployeeTransportListRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao buscar lista de Vale Transporte.',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

export function useInactivateEmployeeTransport() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<void>();

  const fetch = ({ data }: { data: { id: number } }) =>
    fetchData({
      fetcher: () => inactivateEmployeeTransportRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao inativar VT.',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

export function useGenerateEmployeeTransportReceipt() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<Blob>();

  const fetch = ({ data, onSuccess }: UseGetEmployeeTransportReceiptProps) =>
    fetchData({
      fetcher: () => createManyEmployeeTransportRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao gerar recibo de VT',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}
